module.exports = __webpack_public_path__ + "static/media/slide2.a29879b4.webp";